import SolicitacoesDeAtivacaoService from "../../../services/http/services/SaldoDeContas/SolicitacoesDeAtivacaoService";

export const getQuantidadesSolicitacoesSaldoDeContas = async () => {
    try {
        const response = await SolicitacoesDeAtivacaoService.getQuantidadeSocilitacoesNaoConcluidas();
        return response;
    } catch (error: any) {
        return null;
    }
};
